<template>
  <v-container fluid class="pa-4">
    <!-- Section Budget de l'Entreprise -->
    <v-card class="mb-6" elevation="2">
      <v-card-title class="white--text d-flex justify-space-between align-center" style="background-color: #607D8B;">
        <div>
          <v-icon left dark>mdi-domain</v-icon>
          Budget Entreprise
        </div>
        <v-btn
            icon
            dark
            @click="refreshData"
            :loading="loading"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <v-alert color="info" text dense class="mb-4">
          <v-icon left small>mdi-information</v-icon>
          Votre entreprise vous alloue un budget mensuel pour vos repas. Voici le détail de votre utilisation.
        </v-alert>

        <v-row>
          <!-- Jours ouvrés total -->
          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="text-center pa-3" style="border-top: 4px solid #2196F3;">
              <v-icon size="48" color="blue">mdi-wallet</v-icon>
              <h2 class="mt-3">{{ financialDetails.budgetRestant }}</h2>
              <p class="text-subtitle-2 grey--text">Budget restant</p>
              <p class="text-caption grey--text">Décompte mensuel de l'entreprise</p>
            </v-card>
          </v-col>

          <!-- Montant Consommé -->
          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="text-center pa-3" style="border-top: 4px solid #FF9800;">
              <v-icon size="48" color="orange">mdi-cart</v-icon>
              <h2 class="mt-3">{{ financialDetails.montantConsommerMoisEnCours }}</h2>
              <p class="text-subtitle-2 grey--text">Montant Consommé</p>
              <p class="text-caption grey--text">Ce que vous avez dépensé ce mois</p>
            </v-card>
          </v-col>

          <!-- Jours ouvrés restants -->
          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="text-center pa-3" style="border-top: 4px solid #4CAF50;">
              <v-icon size="48" color="green">mdi-home</v-icon>
              <h2 class="mt-3">{{ financialDetails.totalMoisJoursOuvresRestants }}</h2>
              <p class="text-subtitle-2 grey--text">Jours Ouvrés Restants</p>
              <p class="text-caption grey--text">Nombre jours ouvrés restants</p>
            </v-card>
          </v-col>

          <!-- Sera Déduit -->
          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="text-center pa-3" style="border-top: 4px solid #F44336;">
              <v-icon size="48" color="red">mdi-download</v-icon>
              <h2 class="mt-3">{{ financialDetails.seraDeduit }}</h2>
              <p class="text-subtitle-2 grey--text">Sera Déduit</p>
              <p class="text-caption grey--text">De votre salaire ce mois</p>
            </v-card>
          </v-col>
        </v-row>

        <!-- Statistiques Budget Entreprise -->
        <v-row class="mt-4">
          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="primary">mdi-food</v-icon>
                <div>
                  <p class="mb-0 text-caption">Nombre de Repas</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.nbrRepasMoisEnCours }} repas consommés</p>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="orange">mdi-calendar</v-icon>
                <div>
                  <p class="mb-0 text-caption">Dernière consommation</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.derniereConsommationCompany }}
                    ({{ financialDetails.dtDerniereConsommationCompagny }})</p>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="green">mdi-calendar-clock</v-icon>
                <div>
                  <p class="mb-0 text-caption">Jours Restants</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.joursRestants }} jours dans ce mois</p>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="red">mdi-calculator</v-icon>
                <div>
                  <p class="mb-0 text-caption">Budget Quotidien Subventionné</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.budgetQuotidienSubventionner }} / jour</p>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Section Mon Compte Personnel -->
    <v-card class="mb-6" elevation="2">
      <v-card-title class="white--text d-flex justify-space-between align-center" style="background-color: #607D8B;">
        <div>
          <v-icon left dark>mdi-account</v-icon>
          Mon Compte Personnel
        </div>
        <v-btn
            icon
            dark
            @click="refreshData"
            :loading="loading"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <v-alert color="info" text dense class="mb-4">
          <v-icon left small>mdi-information</v-icon>
          Votre argent personnel que vous pouvez utiliser en complément du budget entreprise.
        </v-alert>

        <v-row>
          <!-- Solde Disponible -->
          <v-col cols="12" sm="6">
            <v-card outlined class="text-center pa-3" style="border-top: 4px solid #F44336;">
              <v-icon size="48" color="red">mdi-wallet</v-icon>
              <h2 class="mt-3">{{ financialDetails.soldeDisponiblePersonal }}</h2>
              <p class="text-subtitle-2 grey--text">Solde Disponible</p>
              <p class="text-caption grey--text">Votre argent personnel</p>
            </v-card>
          </v-col>

          <!-- Dépensé ce Mois -->
          <v-col cols="12" sm="6">
            <v-card outlined class="text-center pa-3" style="border-top: 4px solid #FF9800;">
              <v-icon size="48" color="orange">mdi-trending-down</v-icon>
              <h2 class="mt-3">{{ financialDetails.totalConsommationMoisEnCoursPerso }}</h2>
              <p class="text-subtitle-2 grey--text">Dépensé ce Mois</p>
              <p class="text-caption grey--text">Utilisé de votre propre argent</p>
            </v-card>
          </v-col>
        </v-row>

        <!-- Statistiques Compte Personnel -->
        <v-row class="mt-4">
          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="primary">mdi-food</v-icon>
                <div>
                  <p class="mb-0 text-caption">Nombre de Repas (Mois en cours)</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.nbrRepasMoisEnCours }} repas consommés</p>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="orange">mdi-calendar</v-icon>
                <div>
                  <p class="mb-0 text-caption">Dernière consommation</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.derniereConsommationPersonal }}
                    ({{ financialDetails.dtDerniereConsommationPerso }})</p>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="green">mdi-calendar-check</v-icon>
                <div>
                  <p class="mb-0 text-caption">Total consommation (Mois en cours)</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.totalConsommationMoisEnCoursPerso }}</p>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-card outlined class="pa-3">
              <div class="d-flex align-center">
                <v-icon left color="red">mdi-calendar-minus</v-icon>
                <div>
                  <p class="mb-0 text-caption">Total consommation (Mois précédent)</p>
                  <p class="mb-0 font-weight-bold">{{ financialDetails.totalConsommationMoisPrecedentPerso }}</p>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Section Historiques avec Onglets -->
    <v-card elevation="2">
      <v-card-title class="white--text d-flex justify-space-between align-center" style="background-color: #607D8B;">
        <div>
          <v-icon left dark>mdi-history</v-icon>
          Vos Historiques
        </div>
        <v-btn icon dark @click="refreshData" :loading="loading">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-0">
        <v-tabs
            v-model="activeTab"
            centered
            icons-and-text
            height="60"
        >
          <v-tab href="#tab-repas">
            <v-icon class="mb-1">mdi-silverware-fork-knife</v-icon>
            <span class="d-none d-sm-block">Historique des Repas</span>
            <span class="d-block d-sm-none">Repas</span>
          </v-tab>

          <v-tab href="#tab-paiements-externes">
            <v-icon class="mb-1">mdi-wallet-outline</v-icon>
            <span class="d-none d-sm-block">Paiements Externes</span>
            <span class="d-block d-sm-none">Paiements</span>
          </v-tab>

          <v-tab href="#tab-recharges">
            <v-icon class="mb-1">mdi-wallet-plus</v-icon>
            <span class="d-none d-sm-block">Historique des Recharges</span>
            <span class="d-block d-sm-none">Recharges</span>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="activeTab">
          <!-- Tab Historique des Repas -->
          <v-tab-item value="tab-repas">
            <v-container fluid class="pa-4">
              <v-alert color="info" text dense class="mb-4">
                <v-icon left small>mdi-information</v-icon>
                Retrouvez tous vos repas avec les détails de paiement. Vous pouvez filtrer par période ou restaurant.
              </v-alert>

              <!-- Boutons de sélection rapide de période -->
              <v-row class="mb-3">
                <v-col cols="12" class="text-center">
                  <v-btn-toggle
                      v-model="selectedPeriodRepas"
                      mandatory
                      color="primary"
                      dense
                      class="flex-wrap justify-center"
                  >
                    <v-btn value="today" small>
                      <v-icon left small>mdi-calendar-today</v-icon>
                      Aujourd'hui
                    </v-btn>
                    <v-btn value="week" small>
                      <v-icon left small>mdi-calendar-week</v-icon>
                      Cette semaine
                    </v-btn>
                    <v-btn value="month" small>
                      <v-icon left small>mdi-calendar-month</v-icon>
                      Ce mois
                    </v-btn>
                    <v-btn value="last_month" small>
                      <v-icon left small>mdi-calendar-minus</v-icon>
                      Mois dernier
                    </v-btn>
                    <v-btn value="custom" small>
                      <v-icon left small>mdi-calendar-range</v-icon>
                      Personnalisé
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <!-- Sélecteur de plage personnalisée -->
              <v-expand-transition>
                <v-row v-show="selectedPeriodRepas === 'custom'" class="mb-3">
                  <v-col cols="12" sm="6">
                    <v-menu
                        v-model="menuDateDebutRepas"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="formatDateFR(dateDebutRepas)"
                            label="Date de début"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateDebutRepas"
                          @input="menuDateDebutRepas = false"
                          locale="fr"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                        v-model="menuDateFinRepas"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="formatDateFR(dateFinRepas)"
                            label="Date de fin"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateFinRepas"
                          @input="menuDateFinRepas = false"
                          locale="fr"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-expand-transition>

              <!-- Autres filtres -->
              <v-row class="mb-4">
                <v-col cols="12" sm="6">
                  <v-select
                      v-model="selectedRestaurant"
                      :items="restaurantOptions"
                      label="Restaurant"
                      prepend-icon="mdi-silverware"
                      outlined
                      dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                      v-model="searchQueryRepas"
                      label="Rechercher..."
                      prepend-icon="mdi-magnify"
                      outlined
                      dense
                      clearable
                      @click:clear="clearSearchRepas"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Tableau -->
              <v-data-table
                  :headers="headers"
                  :items="filteredTransactions"
                  :items-per-page="10"
                  class="elevation-1"
                  :loading="loading"
                  loading-text="Chargement des données..."
              >
                <template v-slot:[`item.date`]="{ item }">
                  {{ formatDate(item.date) }}
                </template>

                <template v-slot:[`item.montant`]="{ item }">
                  <div class="d-flex align-center justify-end">
                <span :class="{ 'text-h6 primary--text': item.niveau === 'PRINCIPAL', 'font-weight-bold': true }">
                  {{ item.montant }}
                </span>
                    <v-tooltip bottom v-if="item._children && item._children.length > 0">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            small
                            color="orange"
                            v-bind="attrs"
                            v-on="on"
                            class="ml-1"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <div>
                        <div v-for="child in item._children" :key="child.id" class="mb-1">
                          <v-chip x-small :color="getNiveauColor(child.niveau)" dark class="mr-1">
                            {{ formatNiveau(child.niveau) }}
                          </v-chip>
                          {{ child.montant }}
                        </div>
                      </div>
                    </v-tooltip>
                  </div>
                </template>

                <template v-slot:[`item.paiement`]="{ item }">
                  <v-chip small :color="getPaymentColor(item.paiement)" dark>
                    {{ item.paiement }}
                  </v-chip>
                </template>

                <template v-slot:[`item.statut`]="{ item }">
                  <v-icon :color="getStatusColor(item.statut)">
                    {{ getStatusIcon(item.statut) }}
                  </v-icon>
                </template>

                <template v-slot:[`item.niveau`]="{ item }">
                  <v-chip
                      small
                      :color="getNiveauColor(item.niveau)"
                      :outlined="item.niveau !== 'PRINCIPAL'"
                      :dark="item.niveau === 'PRINCIPAL'"
                  >
                    {{ formatNiveau(item.niveau) }}
                  </v-chip>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon small @click="viewDetailsRepas(item)">
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                  <v-btn
                      v-if="canDelete(item)"
                      icon
                      small
                      color="error"
                      @click="deleteTransaction(item)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>

          <!-- Tab Paiements Externes -->
          <v-tab-item value="tab-paiements-externes">
            <v-container fluid class="pa-4">
              <v-alert color="warning" text dense class="mb-4">
                <v-icon left small>mdi-information</v-icon>
                Historique de vos paiements externes (Cash, Wave, Orange Money, etc.) effectués en dehors du système de
                carte.
              </v-alert>

              <!-- Statistiques des paiements externes -->
              <v-row class="mb-4">
                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="text-center pa-3" style="border-top: 4px solid #FF9800;">
                    <v-icon size="40" color="orange">mdi-cash-multiple</v-icon>
                    <h3 class="mt-2">{{ getExternalStatValue('totalAmount') }}</h3>
                    <p class="text-subtitle-2 grey--text">💰 Total Dépensé</p>
                    <p class="text-caption grey--text">{{ getExternalStatValue('totalCount') }} transactions</p>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="text-center pa-3" style="border-top: 4px solid #4CAF50;">
                    <v-icon size="40" color="green">mdi-check-circle</v-icon>
                    <h3 class="mt-2">{{ getExternalStatValue('successCount') }}</h3>
                    <p class="text-subtitle-2 grey--text">✅ Réussies</p>
                    <p class="text-caption grey--text">{{ getExternalStatValue('successAmount') }} FCFA</p>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="text-center pa-3" style="border-top: 4px solid #2196F3;">
                    <v-icon size="40" color="blue">mdi-clock</v-icon>
                    <h3 class="mt-2">{{ getExternalStatValue('pendingCount') }}</h3>
                    <p class="text-subtitle-2 grey--text">⏳ En Attente</p>
                    <p class="text-caption grey--text">{{ getExternalStatValue('pendingAmount') }} FCFA</p>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-card outlined class="text-center pa-3" style="border-top: 4px solid #9C27B0;">
                    <v-icon size="40" color="purple">mdi-calendar</v-icon>
                    <h3 class="mt-2">{{ getLastExternalPaymentDate() }}</h3>
                    <p class="text-subtitle-2 grey--text">📅 Dernier Paiement</p>
                    <p class="text-caption grey--text">{{ getLastExternalPaymentAmount() }}</p>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Boutons de sélection rapide pour paiements externes -->
              <v-row class="mb-3">
                <v-col cols="12" class="text-center">
                  <v-btn-toggle
                      v-model="selectedPeriodExternal"
                      mandatory
                      color="warning"
                      dense
                      class="flex-wrap justify-center"
                  >
                    <v-btn value="today" small>
                      <v-icon left small>mdi-calendar-today</v-icon>
                      Aujourd'hui
                    </v-btn>
                    <v-btn value="week" small>
                      <v-icon left small>mdi-calendar-week</v-icon>
                      Cette semaine
                    </v-btn>
                    <v-btn value="month" small>
                      <v-icon left small>mdi-calendar-month</v-icon>
                      Ce mois
                    </v-btn>
                    <v-btn value="last_month" small>
                      <v-icon left small>mdi-calendar-minus</v-icon>
                      Mois dernier
                    </v-btn>
                    <v-btn value="custom" small>
                      <v-icon left small>mdi-calendar-range</v-icon>
                      Personnalisé
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <!-- Sélecteur de plage personnalisée pour paiements externes -->
              <v-expand-transition>
                <v-row v-show="selectedPeriodExternal === 'custom'" class="mb-3">
                  <v-col cols="12" sm="6">
                    <v-menu
                        v-model="menuDateDebutExternal"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="formatDateFR(dateDebutExternal)"
                            label="Date de début"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateDebutExternal"
                          @input="menuDateDebutExternal = false"
                          locale="fr"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                        v-model="menuDateFinExternal"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="formatDateFR(dateFinExternal)"
                            label="Date de fin"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateFinExternal"
                          @input="menuDateFinExternal = false"
                          locale="fr"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-expand-transition>

              <!-- Filtres pour paiements externes -->
              <v-row class="mb-4">
                <v-col cols="12" sm="4">
                  <v-select
                      v-model="selectedPaymentMethod"
                      :items="paymentMethodOptions"
                      label="Méthode de paiement"
                      prepend-icon="mdi-credit-card"
                      outlined
                      dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-select
                      v-model="selectedStatusExternal"
                      :items="statusExternalOptions"
                      label="Statut"
                      prepend-icon="mdi-check-circle"
                      outlined
                      dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="4">
                  <v-text-field
                      v-model="searchQueryExternal"
                      label="Rechercher..."
                      prepend-icon="mdi-magnify"
                      outlined
                      dense
                      clearable
                      @click:clear="clearSearchExternal"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Tableau des paiements externes -->
              <v-data-table
                  :headers="headersExternal"
                  :items="filteredExternalPayments"
                  :items-per-page="10"
                  class="elevation-1"
                  :loading="loadingExternal"
                  loading-text="Chargement des paiements externes..."
                  :no-data-text="getNoExternalDataText()"
              >
                <template v-slot:[`item.transactionDate`]="{ item }">
                  {{ formatExternalDate(item.transactionDate) }}
                </template>

                <template v-slot:[`item.amount`]="{ item }">
                  <div class="d-flex align-center justify-end">
                      <span class="font-weight-bold text-h6 orange--text">
                        {{ formatExternalAmount(item.amount) }}
                      </span>
                  </div>
                </template>

                <template v-slot:[`item.paymentMethod`]="{ item }">
                  <v-chip small :color="getPaymentMethodColor(item.paymentMethod, item)" dark>
                    <v-icon left small>{{ getPaymentMethodIcon(item.paymentMethod, item) }}</v-icon>
                    {{ item.paymentMethod }}
                  </v-chip>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                  <v-chip small :color="getExternalStatusColor(item.status)">
                    <v-icon left small>{{ getExternalStatusIcon(item.status) }}</v-icon>
                    {{ item.status }}
                  </v-chip>
                </template>

                <template v-slot:[`item.typeAuth`]="{ item }">
                  <v-chip x-small :color="getAuthColor(item.typeAuth)" outlined>
                    {{ item.typeAuth }}
                  </v-chip>
                </template>

                <template v-slot:[`item.customerType`]="{ item }">
                  <v-chip
                      x-small
                      :color="item.customerType === 'Identifié' ? 'success' : 'info'"
                      outlined
                  >
                    {{ item.customerType }}
                  </v-chip>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon small @click="viewDetailsExternal(item)">
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>

                <!-- Custom no-data slot -->
                <template v-slot:no-data>
                  <div class="text-center pa-6">
                    <v-icon size="64" color="grey lighten-1" class="mb-4">
                      mdi-wallet-outline
                    </v-icon>
                    <h3 class="grey--text text--lighten-1 mb-2">
                      {{ getNoExternalDataTitle() }}
                    </h3>
                    <p class="grey--text">
                      {{ getNoExternalDataMessage() }}
                    </p>
                    <v-btn
                        v-if="!loadingExternal && externalPayments.length === 0"
                        color="warning"
                        outlined
                        @click="loadExternalPayments"
                        class="mt-2"
                    >
                      <v-icon left>mdi-refresh</v-icon>
                      Actualiser
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>

          <!-- Tab Historique des Recharges -->
          <v-tab-item value="tab-recharges">
            <v-container fluid class="pa-4">
              <v-alert color="success" text dense class="mb-4">
                <v-icon left small>mdi-information</v-icon>
                Consultez ici toutes vos recharges personnelles (crédits et débits).
              </v-alert>

              <!-- Statistiques des recharges -->
              <v-row class="mb-4" v-if="rechargeStats">
                <v-col cols="12" sm="6">
                  <v-card outlined class="text-center pa-3" style="border-top: 4px solid #4CAF50;">
                    <v-icon size="40" color="green">mdi-wallet-plus</v-icon>
                    <h3 class="mt-2">{{ getStatValue('totalCredits') }}</h3>
                    <p class="text-subtitle-2 grey--text">💰 Total Crédits</p>
                    <p class="text-caption grey--text">{{ getStatValue('countCredits') }} recharges</p>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-card outlined class="text-center pa-3" style="border-top: 4px solid #FF9800;">
                    <v-icon size="40" color="orange">mdi-history</v-icon>
                    <h3 class="mt-2">{{ getLastRechargeDate() }}</h3>
                    <p class="text-subtitle-2 grey--text">📅 Dernière Recharge</p>
                    <p class="text-caption grey--text">{{ getLastRechargeAmount() }}</p>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Boutons de sélection rapide pour recharges -->
              <v-row class="mb-3">
                <v-col cols="12" class="text-center">
                  <v-btn-toggle
                      v-model="selectedPeriodRecharges"
                      mandatory
                      color="success"
                      dense
                      class="flex-wrap justify-center"
                  >
                    <v-btn value="today" small>
                      <v-icon left small>mdi-calendar-today</v-icon>
                      Aujourd'hui
                    </v-btn>
                    <v-btn value="week" small>
                      <v-icon left small>mdi-calendar-week</v-icon>
                      Cette semaine
                    </v-btn>
                    <v-btn value="month" small>
                      <v-icon left small>mdi-calendar-month</v-icon>
                      Ce mois
                    </v-btn>
                    <v-btn value="last_month" small>
                      <v-icon left small>mdi-calendar-minus</v-icon>
                      Mois dernier
                    </v-btn>
                    <v-btn value="custom" small>
                      <v-icon left small>mdi-calendar-range</v-icon>
                      Personnalisé
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>

              <!-- Sélecteur de plage personnalisée pour recharges -->
              <v-expand-transition>
                <v-row v-show="selectedPeriodRecharges === 'custom'" class="mb-3">
                  <v-col cols="12" sm="6">
                    <v-menu
                        v-model="menuDateDebutRecharges"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="formatDateFR(dateDebutRecharges)"
                            label="Date de début"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateDebutRecharges"
                          @input="menuDateDebutRecharges = false"
                          locale="fr"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu
                        v-model="menuDateFinRecharges"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            :value="formatDateFR(dateFinRecharges)"
                            label="Date de fin"
                            prepend-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="dateFinRecharges"
                          @input="menuDateFinRecharges = false"
                          locale="fr"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-expand-transition>

              <!-- Filtres pour recharges -->
              <v-row class="mb-4">
                <v-col cols="12" sm="6" md="3">
                  <v-select
                      v-model="selectedTypeRecharge"
                      :items="typeRechargeOptions"
                      label="Type d'opération"
                      prepend-icon="mdi-swap-vertical"
                      outlined
                      dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-select
                      v-model="selectedStatusRecharge"
                      :items="statusRechargeOptions"
                      label="Statut"
                      prepend-icon="mdi-check-circle"
                      outlined
                      dense
                  ></v-select>
                </v-col>

                <!-- NEW: Payment Method Filter -->
                <v-col cols="12" sm="6" md="3">
                  <v-select
                      v-model="selectedPaymentMethodRecharge"
                      :items="paymentMethodRechargeOptions"
                      label="Méthode de paiement"
                      prepend-icon="mdi-credit-card"
                      outlined
                      dense
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                      v-model="searchQueryRecharges"
                      label="Rechercher..."
                      prepend-icon="mdi-magnify"
                      outlined
                      dense
                      clearable
                      @click:clear="clearSearchRecharges"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Tableau des recharges -->
              <v-data-table
                  :headers="headersRecharges"
                  :items="filteredRecharges"
                  :items-per-page="10"
                  class="elevation-1"
                  :loading="loadingRecharges"
                  loading-text="Chargement des recharges..."
                  :no-data-text="getNoDataText()"
              >
                <template v-slot:[`item.dateTransaction`]="{ item }">
                  {{ formatDate(item.dateTransaction) }}
                </template>

                <template v-slot:[`item.amount`]="{ item }">
                  <div class="d-flex align-center justify-end">
      <span :class="getAmountClass(item.typeOperation)">
        {{ item.typeOperation === 'DEBIT' ? '-' : '+' }}{{ item.amount }} FCFA
      </span>
                  </div>
                </template>

                <template v-slot:[`item.typeOperation`]="{ item }">
                  <v-chip small :color="getTypeOperationColor(item.typeOperation)" dark>
                    <v-icon left small>{{ getTypeOperationIcon(item.typeOperation) }}</v-icon>
                    {{ item.typeOperation }}
                  </v-chip>
                </template>

                <!-- NEW: Payment Method Column -->
                <template v-slot:[`item.paymentMethod`]="{ item }">
                  <v-chip small :color="getPaymentMethodRechargeColor(item.paymentMethod)" dark>
                    <v-icon left small>{{ getPaymentMethodRechargeIcon(item.paymentMethod) }}</v-icon>
                    {{ item.paymentMethod }}
                  </v-chip>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                  <v-chip small :color="getStatusColorRecharge(item.status)">
                    <v-icon left small>{{ getStatusIconRecharge(item.status) }}</v-icon>
                    {{ item.status }}
                  </v-chip>
                </template>

                <template v-slot:[`item.level`]="{ item }">
                  <v-chip small :color="getNiveauColor(item.level)" outlined>
                    {{ formatNiveau(item.level) }}
                  </v-chip>
                </template>

                <template v-slot:[`item.typeAuth`]="{ item }">
                  <v-chip x-small :color="getAuthColor(item.typeAuth)" outlined>
                    {{ item.typeAuth }}
                  </v-chip>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn icon small @click="viewDetailsRecharge(item)">
                    <v-icon small>mdi-eye</v-icon>
                  </v-btn>
                </template>

                <!-- Enhanced no-data slot -->
                <template v-slot:no-data>
                  <div class="text-center pa-6">
                    <v-icon size="64" color="grey lighten-1" class="mb-4">
                      mdi-wallet-outline
                    </v-icon>
                    <h3 class="grey--text text--lighten-1 mb-2">
                      {{ getNoDataTitle() }}
                    </h3>
                    <p class="grey--text">
                      {{ getNoDataMessage() }}
                    </p>
                    <v-btn
                        v-if="!loadingRecharges && recharges.length === 0"
                        color="primary"
                        outlined
                        @click="loadRecharges"
                        class="mt-2"
                    >
                      <v-icon left>mdi-refresh</v-icon>
                      Actualiser
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>

    <!-- Dialog pour les détails de recharge -->
    <v-dialog v-model="detailsRechargeDialog" max-width="500">
      <v-card>
        <v-card-title class="headline success white--text">
          <v-icon left dark>mdi-wallet-plus</v-icon>
          Détails de la recharge
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-html="detailsRechargeContent"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="detailsRechargeDialog = false">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog pour les détails de paiement externe -->
    <v-dialog v-model="detailsExternalDialog" max-width="500">
      <v-card>
        <v-card-title class="headline warning white--text">
          <v-icon left dark>mdi-wallet-outline</v-icon>
          Détails du paiement externe
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-html="detailsExternalContent"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="detailsExternalDialog = false">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog pour les alertes -->
    <v-dialog v-model="alertDialog" max-width="500">
      <v-card>
        <v-card-title :class="alertColor === 'success' ? 'success' : 'error'" class="white--text">
          {{ alertTitle }}
        </v-card-title>
        <v-card-text class="pt-4">
          {{ alertMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="alertDialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog pour les détails de transaction -->
    <v-dialog v-model="detailsDialog" max-width="350">
      <v-card>
        <v-card-title class="headline">
          Détails de la transaction
        </v-card-title>
        <v-card-text>
          <div v-html="detailsContent"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="detailsDialog = false">
            Fermer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading overlay -->
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import apiClient from "../../../config/api.js";
import moment from "moment";

export default {
  name: "RapportsSalarie",
  data() {
    return {
      // Tabs
      activeTab: "tab-repas",

      // Données pour paiements externes
      externalPayments: [],
      externalStats: null,
      loadingExternal: false,

      // Filtres pour paiements externes
      selectedPaymentMethod: "Tous",
      selectedStatusExternal: "Tous",
      searchQueryExternal: "",
      selectedPeriodExternal: "month",
      dateDebutExternal: moment().startOf('month').format('YYYY-MM-DD'),
      dateFinExternal: moment().endOf('month').format('YYYY-MM-DD'),

      // Menus dates externes
      menuDateDebutExternal: false,
      menuDateFinExternal: false,

      // Dialog externe
      detailsExternalDialog: false,
      detailsExternalContent: "",

      // Options externes
      paymentMethodOptions: ["Tous", "Cash", "Wave", "Orange Money", "Autre"],
      statusExternalOptions: ["Tous", "SUCCESS", "PENDING", "FAILED", "CANCELLED"],

      // Headers tableau externes
      headersExternal: [
        {text: "Date", value: "transactionDate", align: "start"},
        {text: "Montant", value: "amount", align: "end"},
        {text: "Méthode", value: "paymentMethod", align: "center"},
        {text: "Type Client", value: "customerType", align: "center"},
        {text: "Authentification", value: "typeAuth", align: "center"},
        {text: "Statut", value: "status", align: "center"},
        {text: "Description", value: "description"},
        {text: "Actions", value: "actions", align: "center", sortable: false}
      ],

      // Données pour recharges
      recharges: [],
      rechargeStats: null,
      loadingRecharges: false,

      // Filtres pour recharges
      selectedTypeRecharge: "Tous",
      selectedStatusRecharge: "Tous",
      selectedPaymentMethodRecharge: "Tous",
      searchQueryRecharges: "",
      selectedPeriodRecharges: "month",
      dateDebutRecharges: moment().startOf('month').format('YYYY-MM-DD'),
      dateFinRecharges: moment().endOf('month').format('YYYY-MM-DD'),

      // Menus dates recharges
      menuDateDebutRecharges: false,
      menuDateFinRecharges: false,

      // Dialog recharge
      detailsRechargeDialog: false,
      detailsRechargeContent: "",

      // Options recharges
      typeRechargeOptions: ["Tous", "CREDIT", "DEBIT"],
      statusRechargeOptions: ["Tous", "SUCCESS", "FAILED", "CANCELLED", "PENDING"],
      paymentMethodRechargeOptions: ["Tous"],

      // Headers tableau recharges
      headersRecharges: [
        {text: "Date", value: "dateTransaction", align: "start"},
        {text: "Montant", value: "amount", align: "end"},
        {text: "Type", value: "typeOperation", align: "center"},
        {text: "Méthode", value: "paymentMethod", align: "center"},
        {text: "Authentification", value: "typeAuth", align: "center"},
        {text: "Niveau", value: "level", align: "center"},
        {text: "Statut", value: "status", align: "center"},
        {text: "Raison", value: "reason"},
        {text: "Actions", value: "actions", align: "center", sortable: false}
      ],

      // Headers pour les transactions (repas)
      headers: [
        {text: "Date", value: "date", align: "start"},
        {text: "Restaurant", value: "restaurant"},
        {text: "Type de Repas", value: "typeRepas"},
        {text: "Montant", value: "montant", align: "end"},
        {text: "Paiement", value: "paiement", align: "center"},
        {text: "Niveau", value: "niveau", align: "center"},
        {text: "Statut", value: "statut", align: "center"},
        {text: "Actions", value: "actions", align: "center", sortable: false}
      ],

      // Filtres pour repas
      selectedPeriodRepas: "month",
      dateDebutRepas: moment().startOf('month').format('YYYY-MM-DD'),
      dateFinRepas: moment().endOf('month').format('YYYY-MM-DD'),
      searchQueryRepas: "",
      menuDateDebutRepas: false,
      menuDateFinRepas: false,

      // Filtres
      selectedRestaurant: "Tous les restaurants",
      detailsDialog: false,
      detailsContent: "",
      loading: false,
      alertDialog: false,
      alertTitle: "",
      alertMessage: "",
      alertColor: "info",

      // Options de filtres
      restaurantOptions: ["Tous les restaurants"],

      // Données
      transactions: [],

      // Infos de balance
      balanceInfos: {
        matricule: "",
        companyName: "",
        soldeCompany: 0,
        soldePersonnel: 0,
        plafondJournalier: 0,
        quotePartSalarialeActual: 0,
        quotePartSalarialePrevious: 0,
        montantCompanyDepenserCeJour: 0,
        montantTotalMoisEnCours: 0,
        montantTotalMoisAvant: 0,
      },

      // Détails financiers
      financialDetails: {
        budgetAllouer: "0",
        nbrRepasMoisEnCours: "0",
        nbrRepasMoisPrecedent: "0",
        montantConsommerMoisEnCours: "0",
        montantConsommerMoisPrecedent: "0",
        derniereConsommationCompany: "0",
        dtDerniereConsommationCompagny: "0",
        derniereConsommationPersonal: "0",
        dtDerniereConsommationPerso: "0",
        budgetRestant: "0",
        joursRestants: "0",
        seraDeduit: "0",
        budgetQuotidienSubventionner: "0",
        plafond: "0",
        soldeDisponibleCompany: "0",
        soldeDisponiblePersonal: "0",
        totalConsommationMoisEnCoursPerso: "0",
        totalConsommationMoisPrecedentPerso: "0",
        totalMoisJoursOuvres: "0",
        totalMoisJoursOuvresRestants: "0",
        totalMoisJoursOuvresEcoules: "0"
      }
    };
  },

  computed: {
    filteredExternalPayments() {
      let filtered = [...this.externalPayments];

      if (this.dateDebutExternal && this.dateFinExternal) {
        filtered = filtered.filter(p => {
          if (!p.transactionDate) return false;

          const transDate = this.parseExternalDate(p.transactionDate);
          if (!transDate || !transDate.isValid()) return false;

          const isInRange = transDate.isSameOrAfter(this.dateDebutExternal, 'day') &&
              transDate.isSameOrBefore(this.dateFinExternal, 'day');

          return isInRange;
        });
      }

      if (this.selectedPaymentMethod && this.selectedPaymentMethod !== "Tous") {
        filtered = filtered.filter(p => p.paymentMethod === this.selectedPaymentMethod);
      }

      if (this.selectedStatusExternal && this.selectedStatusExternal !== "Tous") {
        filtered = filtered.filter(p => p.status === this.selectedStatusExternal);
      }

      if (this.searchQueryExternal) {
        const query = this.searchQueryExternal.toLowerCase();
        filtered = filtered.filter(p =>
            (p.description && p.description.toLowerCase().includes(query)) ||
            p.amount.toString().includes(query) ||
            (p.transactionUid && p.transactionUid.toLowerCase().includes(query)) ||
            (p.customerName && p.customerName.toLowerCase().includes(query))
        );
      }

      return filtered;
    },

    filteredRecharges() {
      let filtered = [...this.recharges];

      console.log("Starting recharge filtering with", filtered.length, "recharges");

      if (this.dateDebutRecharges && this.dateFinRecharges) {
        const beforeFilter = filtered.length;
        filtered = filtered.filter(r => {
          if (!r.dateTransaction) {
            console.log("Recharge missing dateTransaction:", r);
            return false;
          }
          const transDate = moment(r.dateTransaction);
          const isValid = transDate.isValid();
          const isInRange = transDate.isSameOrAfter(this.dateDebutRecharges, 'day') &&
              transDate.isSameOrBefore(this.dateFinRecharges, 'day');

          if (!isValid) {
            console.log("Invalid recharge date format:", r.dateTransaction, "for recharge:", r);
          }

          return isValid && isInRange;
        });
        console.log(`Recharge date filter: ${beforeFilter} -> ${filtered.length} recharges`);
      }

      if (this.selectedTypeRecharge && this.selectedTypeRecharge !== "Tous") {
        const beforeFilter = filtered.length;
        filtered = filtered.filter(r => r.typeOperation === this.selectedTypeRecharge);
        console.log(`Recharge type filter: ${beforeFilter} -> ${filtered.length} recharges`);
      }

      if (this.selectedStatusRecharge && this.selectedStatusRecharge !== "Tous") {
        const beforeFilter = filtered.length;
        filtered = filtered.filter(r => r.status === this.selectedStatusRecharge);
        console.log(`Recharge status filter: ${beforeFilter} -> ${filtered.length} recharges`);
      }

      // NEW: Payment method filter for recharges
      if (this.selectedPaymentMethodRecharge && this.selectedPaymentMethodRecharge !== "Tous") {
        const beforeFilter = filtered.length;
        filtered = filtered.filter(r => r.paymentMethod === this.selectedPaymentMethodRecharge);
        console.log(`Payment method filter: ${beforeFilter} -> ${filtered.length} recharges`);
      }

      if (this.searchQueryRecharges) {
        const beforeFilter = filtered.length;
        const query = this.searchQueryRecharges.toLowerCase();
        filtered = filtered.filter(r =>
            (r.reason && r.reason.toLowerCase().includes(query)) ||
            (r.paymentMethod && r.paymentMethod.toLowerCase().includes(query)) ||
            r.amount.toString().includes(query) ||
            (r.transactionUid && r.transactionUid.toLowerCase().includes(query))
        );
        console.log(`Recharge search filter: ${beforeFilter} -> ${filtered.length} recharges`);
      }

      console.log("Final filtered recharges:", filtered);
      return filtered;
    },

    filteredTransactions() {
      let filtered = [...this.transactions];

      console.log("Starting transaction filtering with", filtered.length, "transactions");

      // Filtre par période sélectionnée
      if (this.dateDebutRepas && this.dateFinRepas) {
        const beforeFilter = filtered.length;
        filtered = filtered.filter(t => {
          if (!t.date) {
            console.log("Transaction missing date:", t);
            return false;
          }
          const transDate = moment(t.date);
          const isValid = transDate.isValid();
          const isInRange = transDate.isSameOrAfter(this.dateDebutRepas, 'day') &&
              transDate.isSameOrBefore(this.dateFinRepas, 'day');

          if (!isValid) {
            console.log("Invalid date format:", t.date, "for transaction:", t);
          }

          return isValid && isInRange;
        });
        console.log(`Transaction date filter: ${beforeFilter} -> ${filtered.length} transactions`);
      }

      // Filtre par restaurant
      if (this.selectedRestaurant && this.selectedRestaurant !== "Tous les restaurants") {
        const beforeFilter = filtered.length;
        filtered = filtered.filter(t => t.restaurant === this.selectedRestaurant);
        console.log(`Restaurant filter: ${beforeFilter} -> ${filtered.length} transactions`);
      }

      // Filtre par recherche
      if (this.searchQueryRepas) {
        const beforeFilter = filtered.length;
        const query = this.searchQueryRepas.toLowerCase();
        filtered = filtered.filter(t =>
            (t.restaurant && t.restaurant.toLowerCase().includes(query)) ||
            (t.typeRepas && t.typeRepas.toLowerCase().includes(query)) ||
            (t.montant && t.montant.toLowerCase().includes(query))
        );
        console.log(`Search filter: ${beforeFilter} -> ${filtered.length} transactions`);
      }

      console.log("Final filtered transactions:", filtered);
      return filtered;
    },
  },

  watch: {
    selectedPeriodRecharges: {
      handler(newVal) {
        this.updateDateRangeRecharges(newVal);
        if (this.activeTab === 'tab-recharges') {
          this.$nextTick(() => {
            this.calculateRechargeStatsFromTransactions();
          });
        }
      },
      immediate: false
    },

    filteredRecharges: {
      handler() {
        if (this.activeTab === 'tab-recharges') {
          setTimeout(() => {
            this.calculateRechargeStatsFromTransactions();
          }, 500);
        }
      },
      immediate: false
    },

    selectedPeriodRepas(newVal) {
      this.updateDateRangeRepas(newVal);
    },

    // CORRECTION : Watcher pour mettre à jour les stats des paiements externes
    selectedPeriodExternal: {
      handler(newVal) {
        this.updateDateRangeExternal(newVal);
        if (this.activeTab === 'tab-paiements-externes') {
          this.$nextTick(() => {
            this.calculateExternalStatsFromTransactions();
          });
        }
      },
      immediate: false
    },

    // CORRECTION : Watcher pour les paiements externes filtrés
    filteredExternalPayments: {
      handler() {
        if (this.activeTab === 'tab-paiements-externes') {
          this.$nextTick(() => {
            this.calculateExternalStatsFromTransactions();
          });
        }
      },
      immediate: false
    },

    activeTab(newVal) {
      console.log("Active tab changed to:", newVal);
      if (newVal === 'tab-recharges') {
        console.log("Loading recharges data...");
        this.loadRecharges();
      } else if (newVal === 'tab-paiements-externes') {
        console.log("Loading external payments data...");
        this.loadExternalPayments();
        // CORRECTION : Calculer les stats immédiatement
        this.$nextTick(() => {
          this.calculateExternalStatsFromTransactions();
        });
      }
    },
  },

  created() {
    this.initialize();
    this.updateDateRangeRepas(this.selectedPeriodRepas);
    this.updateDateRangeRecharges(this.selectedPeriodRecharges);
    this.updateDateRangeExternal(this.selectedPeriodExternal);
  },

  methods: {
    formatDateFR(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },

    async loadExternalPayments() {
      console.log("=== LOADING EXTERNAL PAYMENTS ===");
      this.loadingExternal = true;

      try {
        await Promise.allSettled([
          this.getExternalPayments(),
          this.getExternalPaymentStatistics()
        ]);

        console.log("External payments loaded successfully");

        if (this.externalPayments.length === 0) {
          console.log("No external payment history found for this employee");
          this.showAlert("info", "Information",
              "Aucun historique de paiement externe trouvé. Vous n'avez pas encore effectué de paiement externe.");
        }

      } catch (error) {
        console.error("Error during external payments loading:", error);
        this.showAlert("error", "Erreur", "Impossible de charger l'historique des paiements externes");
      } finally {
        this.loadingExternal = false;
        console.log("External payments loading finished");
      }
    },

    async getExternalPayments() {
      const startDate = moment().subtract(6, "months").format("YYYY-MM-DD");
      const endDate = moment().add(1, "day").format("YYYY-MM-DD");

      const url = `${this.$store.getters.user.baseUrl}/api/external-payments/history/employee/${sessionStorage.getItem("userId")}/${sessionStorage.getItem("companyId")}`;

      try {
        console.log("=== EXTERNAL PAYMENTS API CALL ===");
        console.log("URL:", url);
        console.log("Params:", {startDate, endDate});

        const response = await apiClient.get(url, {
          params: {startDate, endDate}
        });

        console.log("Raw external payments API response:", response.data);

        if (response.data && Array.isArray(response.data)) {
          console.log("External payments data is array, length:", response.data.length);

          this.externalPayments = response.data.map(item => ({
            id: item.id,
            transactionUid: item.transactionUid,
            transactionDate: item.transactionDate,
            amount: item.amount,
            currency: item.currency || 'XOF',
            paymentMethod: item.paymentMethod ? item.paymentMethod.name : 'N/A',
            status: item.status,
            typeAuth: item.typeAuth || 'N/A',
            description: item.description || 'N/A',
            externalReference: item.externalReference || '',
            customerType: item.account ? 'Identifié' : 'Anonyme',
            customerName: item.account ?
                item.displayCustomerName || `${item.account.accountFirstname} ${item.account.accountLastname}` :
                item.anonymousCustomerName || 'Client anonyme',
            customerPhone: item.account ?
                item.account.accountPhonenumber || 'N/A' :
                item.anonymousCustomerPhone || 'N/A',
            customerEmail: item.account ?
                item.displayCustomerEmail || item.account.accountEmail :
                item.anonymousCustomerEmail || 'N/A',
            origin: item.origin || 'N/A',
            processedBy: item.processedBy || 'N/A',
            notes: item.notes || '',
            failureReason: item.failureReason || '',
            creationDate: item.creationDate,
            revisedDate: item.revisedDate,
            paymentMethodColor: item.paymentMethod ? item.paymentMethod.color : null,
            paymentMethodIcon: item.paymentMethod ? item.paymentMethod.icon : null,
            paymentMethodDescription: item.paymentMethod ? item.paymentMethod.description : null,
            isAnonymous: item.anonymousTransaction || false,
            accountInfo: item.account || null
          }));

          console.log("Mapped external payments:", this.externalPayments);

          // Extraire les méthodes de paiement uniques
          const paymentMethods = [...new Set(this.externalPayments.map(p => p.paymentMethod))];
          this.paymentMethodOptions = ["Tous", ...paymentMethods];
          console.log("Payment method options:", this.paymentMethodOptions);

        } else {
          console.log("Unexpected response structure or empty data:", response.data);
          this.externalPayments = [];
        }
      } catch (error) {
        console.error("Error loading external payments:", error);
        this.externalPayments = [];
        this.showAlert("error", "Erreur API",
            `Impossible de charger les paiements externes. Status: ${error.response?.status || 'Inconnu'}`);
      }
    },

    async getExternalPaymentStatistics() {
      // CORRECTION : Calcul des statistiques à partir des transactions chargées
      this.calculateExternalStatsFromTransactions();
    },

    // CORRECTION : Nouvelle méthode pour calculer les stats externes
    calculateExternalStatsFromTransactions() {
      // CORRECTION : Utiliser les paiements filtrés au lieu de tous les paiements
      const paymentsToAnalyze = this.filteredExternalPayments || [];

      if (!paymentsToAnalyze || paymentsToAnalyze.length === 0) {
        this.externalStats = {
          totalAmount: 0,
          totalCount: 0,
          successCount: 0,
          successAmount: 0,
          pendingCount: 0,
          pendingAmount: 0,
          failedCount: 0,
          failedAmount: 0,
          lastPayment: null
        };
        return;
      }

      const stats = {
        totalAmount: 0,
        totalCount: paymentsToAnalyze.length,
        successCount: 0,
        successAmount: 0,
        pendingCount: 0,
        pendingAmount: 0,
        failedCount: 0,
        failedAmount: 0,
        lastPayment: null
      };

      const sortedPayments = [...paymentsToAnalyze].sort((a, b) =>
          moment(b.transactionDate).valueOf() - moment(a.transactionDate).valueOf()
      );

      if (sortedPayments.length > 0) {
        stats.lastPayment = {
          date: sortedPayments[0].transactionDate,
          amount: sortedPayments[0].amount
        };
      }

      paymentsToAnalyze.forEach(payment => {
        const amount = parseInt(payment.amount) || 0;
        stats.totalAmount += amount;

        switch (payment.status) {
          case 'SUCCESS':
            stats.successCount++;
            stats.successAmount += amount;
            break;
          case 'PENDING':
            stats.pendingCount++;
            stats.pendingAmount += amount;
            break;
          case 'FAILED':
          case 'CANCELLED':
            stats.failedCount++;
            stats.failedAmount += amount;
            break;
        }
      });

      this.externalStats = stats;
      console.log("Stats externes mises à jour:", this.externalStats);
    },

    updateDateRangeExternal(period) {
      switch (period) {
        case 'today':
          this.dateDebutExternal = moment().format('YYYY-MM-DD');
          this.dateFinExternal = moment().format('YYYY-MM-DD');
          break;
        case 'week':
          this.dateDebutExternal = moment().startOf('week').format('YYYY-MM-DD');
          this.dateFinExternal = moment().endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          this.dateDebutExternal = moment().startOf('month').format('YYYY-MM-DD');
          this.dateFinExternal = moment().endOf('month').format('YYYY-MM-DD');
          break;
        case 'last_month':
          this.dateDebutExternal = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.dateFinExternal = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
      }
    },

    formatExternalDate(date) {
      if (!date || date === "0") return "N/A";

      let parsedDate;
      if (typeof date === 'string' && date.includes(' ')) {
        parsedDate = moment(date, "YYYY-MM-DD HH:mm:ss");
      } else {
        parsedDate = moment(date);
      }

      return parsedDate.isValid() ? parsedDate.format("DD-MM-YYYY HH:mm") : "Date invalide";
    },

    formatExternalAmount(amount) {
      if (!amount || amount === 0) return "0 FCFA";
      return new Intl.NumberFormat('fr-FR').format(amount) + " FCFA";
    },

    parseExternalDate(date) {
      if (!date) return null;

      if (typeof date === 'string' && date.includes(' ')) {
        return moment(date, "YYYY-MM-DD HH:mm:ss");
      } else {
        return moment(date);
      }
    },

    getPaymentMethodColor(method, item = null) {
      if (item && item.paymentMethodColor) {
        return item.paymentMethodColor;
      }

      const colors = {
        "Cash": "green",
        "Wave": "blue",
        "Orange Money": "orange",
        "Carte Bancaire": "purple",
        "Espèces": "green",
        "Autre": "grey"
      };
      return colors[method] || "grey";
    },

    getPaymentMethodIcon(method, item = null) {
      if (item && item.paymentMethodIcon) {
        return `mdi-${item.paymentMethodIcon}`;
      }

      const icons = {
        "Cash": "mdi-cash",
        "Wave": "mdi-water",
        "Orange Money": "mdi-phone",
        "Carte Bancaire": "mdi-credit-card",
        "Espèces": "mdi-cash",
        "Autre": "mdi-wallet"
      };
      return icons[method] || "mdi-wallet";
    },

    getExternalStatusColor(status) {
      const colors = {
        "SUCCESS": "success",
        "FAILED": "error",
        "CANCELLED": "warning",
        "PENDING": "info"
      };
      return colors[status] || "grey";
    },

    getExternalStatusIcon(status) {
      const icons = {
        "SUCCESS": "mdi-check",
        "FAILED": "mdi-close",
        "CANCELLED": "mdi-cancel",
        "PENDING": "mdi-clock"
      };
      return icons[status] || "mdi-help";
    },

    getExternalStatValue(statKey) {
      if (!this.externalStats) return "0";

      const value = this.externalStats[statKey];
      if (value === null || value === undefined) return "0";

      if (statKey.includes('Amount')) {
        return this.formatNumber(value);
      }

      return value.toString();
    },

    getLastExternalPaymentDate() {
      if (!this.externalStats || !this.externalStats.lastPayment) {
        return "Aucun";
      }
      return this.formatExternalDate(this.externalStats.lastPayment.date);
    },

    getLastExternalPaymentAmount() {
      if (!this.externalStats || !this.externalStats.lastPayment) {
        return "Aucun paiement effectué";
      }
      return `${this.externalStats.lastPayment.amount} FCFA`;
    },

    viewDetailsExternal(item) {
      const details = `
        <strong style="color: #FF9800;">💰 Montant</strong><br>
        <span style="font-size: 18px; font-weight: bold; color: #FF9800;">
          ${this.formatExternalAmount(item.amount)}
        </span><br><br>

        <strong style="color: #FF9800;">📅 Date et Heure</strong><br>
        ${this.formatExternalDate(item.transactionDate)}<br><br>

        <strong style="color: #FF9800;">💳 Méthode de Paiement</strong><br>
        ${item.paymentMethod}<br><br>

        <strong style="color: #FF9800;">👤 Type de Client</strong><br>
        ${item.customerType}<br><br>

        <strong style="color: #FF9800;">👥 Client</strong><br>
        ${item.customerName}<br>
        ${item.customerPhone || 'N/A'}<br><br>

        <strong style="color: #FF9800;">🔐 Authentification</strong><br>
        ${item.typeAuth}<br><br>

        <strong style="color: #FF9800;">✅ Statut</strong><br>
        ${item.status}<br><br>

        <strong style="color: #FF9800;">📝 Description</strong><br>
        ${item.description}<br><br>

        ${item.externalReference ? `<strong style="color: #FF9800;">🔗 Référence Externe</strong><br>${item.externalReference}<br><br>` : ''}

        ${item.failureReason ? `<strong style="color: #F44336;">❌ Raison d'Échec</strong><br>${item.failureReason}<br><br>` : ''}

        ${item.notes ? `<strong style="color: #FF9800;">📋 Notes</strong><br>${item.notes}<br><br>` : ''}

        <hr style="margin: 15px 0;">
        <small style="color: #757575;">
          Transaction ID: ${item.transactionUid}<br>
          Référence: #${item.id}<br>
          ${item.processedBy ? `Traité par: ${item.processedBy}` : ''}
        </small>
`;

      this.detailsExternalDialog = true;
      this.detailsExternalContent = details;
    },

    clearSearchExternal() {
      this.searchQueryExternal = "";
    },

    getNoExternalDataText() {
      if (this.loadingExternal) {
        return "Chargement des paiements externes...";
      }
      if (this.externalPayments.length === 0) {
        return "Aucun paiement externe trouvé";
      }
      return "Aucun paiement externe correspond aux filtres sélectionnés";
    },

    getNoExternalDataTitle() {
      if (this.externalPayments.length === 0) {
        return "Aucun historique de paiement externe";
      }
      return "Aucun résultat";
    },

    getNoExternalDataMessage() {
      if (this.externalPayments.length === 0) {
        return "Vous n'avez effectué aucun paiement externe pour le moment.";
      }
      return "Essayez de modifier vos filtres ou votre période de recherche.";
    },

    // ===== MÉTHODES POUR RECHARGES =====

    getNoDataText() {
      if (this.loadingRecharges) {
        return "Chargement des recharges...";
      }
      if (this.recharges.length === 0) {
        return "Aucune recharge trouvée";
      }
      return "Aucune recharge correspond aux filtres sélectionnés";
    },

    getNoDataTitle() {
      if (this.recharges.length === 0) {
        return "Aucun historique de recharge";
      }
      return "Aucun résultat";
    },

    getNoDataMessage() {
      if (this.recharges.length === 0) {
        return "Vous n'avez effectué aucune recharge sur votre compte personnel pour le moment.";
      }
      return "Essayez de modifier vos filtres ou votre période de recherche.";
    },

    // CORRECTION : Méthodes de statistiques améliorées qui gèrent les données vides
    getStatValue(statKey) {
      if (!this.rechargeStats) return "0";

      const value = this.rechargeStats[statKey];
      if (value === null || value === undefined) return "0";

      if (statKey.includes('total') || statKey.includes('Credits') || statKey.includes('Debits')) {
        return this.formatNumber(value);
      }

      return value.toString();
    },

    getLastRechargeDate() {
      if (!this.rechargeStats || !this.rechargeStats.lastRecharge) {
        return "Aucune";
      }
      return this.formatDate(this.rechargeStats.lastRecharge.date);
    },

    getLastRechargeAmount() {
      if (!this.rechargeStats || !this.rechargeStats.lastRecharge) {
        return "Aucune recharge effectuée";
      }
      return `${this.rechargeStats.lastRecharge.amount} FCFA`;
    },

    // CORRECTION : Formatage de nombre amélioré
    formatNumber(value) {
      if (!value || value === 0) return "0";
      return new Intl.NumberFormat('fr-FR').format(value);
    },

    // CORRECTION : loadRecharges avec gestion d'erreurs complète
    async loadRecharges() {
      console.log("=== LOADING RECHARGES ===");
      this.loadingRecharges = true;

      try {
        await Promise.allSettled([
          this.getRecharges(),
          this.getRechargeStatistics()
        ]);

        console.log("Recharges loaded successfully");

        // Si aucune recharge trouvée, afficher un message convivial
        if (this.recharges.length === 0) {
          console.log("No recharge history found for this employee");
          this.showAlert("info", "Information",
              "Aucun historique de recharge trouvé. Vous n'avez pas encore effectué de recharge sur votre compte personnel.");
        }

      } catch (error) {
        console.error("Error during recharges loading:", error);
        this.showAlert("error", "Erreur", "Impossible de charger l'historique des recharges");
      } finally {
        this.loadingRecharges = false;
        console.log("Recharges loading finished");

        // Debug l'état final
        this.$nextTick(() => {
          this.debugRecharges();
        });
      }
    },

    // CORRECTION : Méthode de debugging améliorée
    debugRecharges() {
      console.log("=== RECHARGES DEBUG ===");
      console.log("Raw recharges:", this.recharges);
      console.log("Recharge stats:", this.rechargeStats);
      console.log("Loading state:", this.loadingRecharges);
      console.log("Date filters:", {
        dateDebutRecharges: this.dateDebutRecharges,
        dateFinRecharges: this.dateFinRecharges,
        selectedPeriodRecharges: this.selectedPeriodRecharges
      });
      console.log("Other filters:", {
        selectedTypeRecharge: this.selectedTypeRecharge,
        selectedStatusRecharge: this.selectedStatusRecharge,
        searchQueryRecharges: this.searchQueryRecharges
      });
      console.log("Filtered recharges:", this.filteredRecharges);
      console.log("Headers recharges:", this.headersRecharges);
      console.log("=======================");
    },

    // CORRECTION : Méthode getRecharges améliorée
    async getRecharges() {
      const startDate = moment().subtract(6, "months").format("YYYY-MM-DD");
      const endDate = moment().add(1, "day").format("YYYY-MM-DD");
      const url = `${this.$store.getters.user.baseUrl}/api/wallet/recharge/history/employee/${sessionStorage.getItem("userId")}/${sessionStorage.getItem("companyId")}`;

      try {
        console.log("=== RECHARGES API CALL ===");
        console.log("URL:", url);
        console.log("Params:", {
          startDate: startDate,
          endDate: endDate,
          requesterId: sessionStorage.getItem("accountId")
        });

        const response = await apiClient.get(url, {
          params: {
            startDate: startDate,
            endDate: endDate,
            requesterId: sessionStorage.getItem("accountId")
          }
        });

        console.log("Raw recharges API response:", response.data);

        if (response.data && Array.isArray(response.data)) {
          console.log("Recharges data is array, length:", response.data.length);

          this.recharges = response.data.map(item => ({
            id: item.id,
            dateTransaction: item.dateTransaction,
            amount: item.amount,
            typeOperation: item.typeOperation,
            typeAuth: item.typeAuth,
            level: item.level,
            status: item.status,
            reason: item.reason || 'N/A',
            motifFailed: item.motifFailed,
            transactionUid: item.transactionUid,
            balanceBefore: item.balanceBefore,
            balanceAfter: item.balanceAfter,
            origin: item.origin,
            senderId: item.senderId,
            paymentMethod: item.paymentMethod || 'N/A'
          }));

          console.log("Mapped recharges:", this.recharges);

          // NEW: Extract unique payment methods for filtering
          const paymentMethods = [...new Set(this.recharges.map(r => r.paymentMethod).filter(pm => pm && pm !== 'N/A'))];
          this.paymentMethodRechargeOptions = ["Tous", ...paymentMethods];
          console.log("Payment method options for recharges:", this.paymentMethodRechargeOptions);
        } else if (response.data && response.data.status === 200 && response.data.datas) {
          // Structure de réponse alternative
          console.log("Recharges data in .datas property:", response.data.datas);

          this.recharges = response.data.datas.map(item => ({
            id: item.id,
            dateTransaction: item.dateTransaction,
            amount: item.amount,
            typeOperation: item.typeOperation,
            typeAuth: item.typeAuth,
            level: item.level,
            status: item.status,
            reason: item.reason || 'N/A',
            motifFailed: item.motifFailed,
            transactionUid: item.transactionUid,
            balanceBefore: item.balanceBefore,
            balanceAfter: item.balanceAfter,
            origin: item.origin,
            senderId: item.senderId,
            paymentMethod: item.paymentMethod || 'N/A'
          }));

          console.log("Mapped recharges from .datas:", this.recharges);

          // NEW: Extract unique payment methods for filtering
          const paymentMethods = [...new Set(this.recharges.map(r => r.paymentMethod).filter(pm => pm && pm !== 'N/A'))];
          this.paymentMethodRechargeOptions = ["Tous", ...paymentMethods];
          console.log("Payment method options for recharges:", this.paymentMethodRechargeOptions);
        } else {
          console.log("Unexpected response structure or empty data:", response.data);
          this.recharges = [];
        }
      } catch (error) {
        console.error("Error loading recharges:", error);
        console.error("Error details:", {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data
        });
        this.recharges = [];
      }
    },

    // CORRECTION : Méthode getRechargeStatistics améliorée
    async getRechargeStatistics() {
      const startDate = moment().subtract(6, "months").format("YYYY-MM-DD");
      const endDate = moment().add(1, "day").format("YYYY-MM-DD");
      const url = `${this.$store.getters.user.baseUrl}/api/wallet/recharge/statistics/employee/${sessionStorage.getItem("userId")}/${sessionStorage.getItem("companyId")}`;

      try {
        console.log("=== RECHARGE STATISTICS API CALL ===");
        console.log("URL:", url);

        const response = await apiClient.get(url, {
          params: {
            startDate: startDate,
            endDate: endDate,
            requesterId: sessionStorage.getItem("accountId")
          }
        });

        console.log("Recharge statistics response:", response.data);

        if (response.data) {
          this.rechargeStats = response.data;
          console.log("Recharge stats set:", this.rechargeStats);
        }
      } catch (error) {
        console.error("Error loading recharge statistics:", error);
        console.error("Stats error details:", {
          message: error.message,
          status: error.response?.status,
          data: error.response?.data
        });
        this.rechargeStats = {
          totalCredits: 0,
          totalDebits: 0,
          countCredits: 0,
          countDebits: 0,
          netBalance: 0,
          lastRecharge: null
        };
      }
    },

    calculateRechargeStatsFromTransactions() {
      console.log("=== DEBUGGING CALCUL STATS RECHARGES ===");
      console.log("📅 Période actuelle:", this.selectedPeriodRecharges);
      console.log("📅 Date début:", this.dateDebutRecharges);
      console.log("📅 Date fin:", this.dateFinRecharges);
      console.log("📊 Recharges brutes:", this.recharges.length);

      const rechargesToAnalyze = this.recharges.filter(r => {
        if (!r.dateTransaction) return false;

        const transDate = moment(r.dateTransaction);
        if (!transDate.isValid()) return false;

        return transDate.isSameOrAfter(this.dateDebutRecharges, 'day') &&
            transDate.isSameOrBefore(this.dateFinRecharges, 'day');
      });

      console.log("📊 Recharges filtrées (dates seulement):", rechargesToAnalyze.length);

      if (this.rechargeStats && rechargesToAnalyze.length > 0) {
        const dynamicTotal = rechargesToAnalyze
            .filter(r => r.typeOperation === 'CREDIT')
            .reduce((sum, r) => sum + (parseInt(r.amount) || 0), 0);

        console.log("💰 Comparaison totaux:");
        console.log("  - API synchronisé:", this.rechargeStats.totalCredits || 0);
        console.log("  - Calcul dynamique:", dynamicTotal);

        const difference = Math.abs((this.rechargeStats.totalCredits || 0) - dynamicTotal);
        if (difference > 0) {
          console.warn("⚠️ DIFFÉRENCE détectée:", difference, "FCFA");
        } else {
          console.log("✅ Totaux cohérents - Synchronisation réussie");
        }
      }

      if (!rechargesToAnalyze || rechargesToAnalyze.length === 0) {
        this.rechargeStats = {
          totalCredits: 0,
          countCredits: 0,
          totalDebits: 0,
          countDebits: 0,
          lastRecharge: null
        };
        console.log("📊 Stats vides - Aucune recharge filtrée");
        return;
      }

      const stats = {
        totalCredits: 0,
        countCredits: 0,
        totalDebits: 0,
        countDebits: 0,
        lastRecharge: null
      };

      const sortedRecharges = [...rechargesToAnalyze].sort((a, b) =>
          moment(b.dateTransaction).valueOf() - moment(a.dateTransaction).valueOf()
      );

      if (sortedRecharges.length > 0) {
        stats.lastRecharge = {
          date: sortedRecharges[0].dateTransaction,
          amount: sortedRecharges[0].amount
        };
      }

      console.log("📋 Détail des recharges filtrées:");
      rechargesToAnalyze.forEach((r, index) => {
        console.log(`${index + 1}. ${r.dateTransaction} - ${r.typeOperation} - ${r.amount} FCFA`);
      });

      rechargesToAnalyze.forEach(recharge => {
        const amount = parseInt(recharge.amount) || 0;

        if (recharge.typeOperation === 'CREDIT') {
          stats.totalCredits += amount;
          stats.countCredits++;
        } else if (recharge.typeOperation === 'DEBIT') {
          stats.totalDebits += amount;
          stats.countDebits++;
        }
      });

      this.rechargeStats = {
        ...this.rechargeStats,
        totalCredits: stats.totalCredits,
        countCredits: stats.countCredits,
        totalDebits: stats.totalDebits,
        countDebits: stats.countDebits,
        lastRecharge: stats.lastRecharge
      };

      console.log("📊 Stats calculées:", stats);
      console.log("📊 Stats API (utilisées pour affichage):", this.rechargeStats);
      console.log("===================================");
    },

    updateDateRangeRecharges(period) {
      moment.locale('fr');

      console.log("🔄 Updating date range for period:", period);

      switch (period) {
        case 'today':
          this.dateDebutRecharges = moment().format('YYYY-MM-DD');
          this.dateFinRecharges = moment().format('YYYY-MM-DD');
          break;
        case 'week': {
          let weekStart = moment().startOf('isoWeek');
          let weekEnd = moment().endOf('isoWeek');
          const monthStart = moment().startOf('month');
          const monthEnd = moment().endOf('month');

          if (weekStart.isBefore(monthStart)) {
            console.log("⚠️ Semaine déborde avant le mois, limitation au début du mois");
            weekStart = monthStart;
          }
          if (weekEnd.isAfter(monthEnd)) {
            console.log("⚠️ Semaine déborde après le mois, limitation à la fin du mois");
            weekEnd = monthEnd;
          }

          this.dateDebutRecharges = weekStart.format('YYYY-MM-DD');
          this.dateFinRecharges = weekEnd.format('YYYY-MM-DD');

          console.log("📅 Semaine limitée au mois:", this.dateDebutRecharges, "au", this.dateFinRecharges);
          break;
        }
        case 'month':
          this.dateDebutRecharges = moment().startOf('month').format('YYYY-MM-DD');
          this.dateFinRecharges = moment().endOf('month').format('YYYY-MM-DD');
          break;
        case 'last_month':
          this.dateDebutRecharges = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.dateFinRecharges = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
        default:
          break;
      }

      console.log("📅 New date range:", this.dateDebutRecharges, "to", this.dateFinRecharges);

      if (this.activeTab === 'tab-recharges' && this.recharges.length > 0) {
        this.$nextTick(() => {
          this.calculateRechargeStatsFromTransactions();
        });
      }
    },

    // Méthodes utilitaires pour les recharges
    getTypeOperationColor(type) {
      return type === "CREDIT" ? "success" : "error";
    },

    getTypeOperationIcon(type) {
      return type === "CREDIT" ? "mdi-plus" : "mdi-minus";
    },

    getStatusColorRecharge(status) {
      const colors = {
        "SUCCESS": "success",
        "FAILED": "error",
        "CANCELLED": "warning",
        "PENDING": "info"
      };
      return colors[status] || "grey";
    },

    getStatusIconRecharge(status) {
      const icons = {
        "SUCCESS": "mdi-check",
        "FAILED": "mdi-close",
        "CANCELLED": "mdi-cancel",
        "PENDING": "mdi-clock"
      };
      return icons[status] || "mdi-help";
    },

    getAmountClass(typeOperation) {
      return {
        'font-weight-bold': true,
        'success--text': typeOperation === 'CREDIT',
        'error--text': typeOperation === 'DEBIT'
      };
    },

    getAuthColor(typeAuth) {
      const colors = {
        "MANUEL": "primary",
        "CARTE": "info",
        "BIO": "purple",
        "AUTOMATIC": "orange"
      };
      return colors[typeAuth] || "grey";
    },

    // CORRECTION : viewDetailsRecharge améliorée
    viewDetailsRecharge(item) {
      const details = `
    <strong style="color: #4CAF50;">💰 Montant</strong><br>
    <span style="font-size: 18px; font-weight: bold; color: ${item.typeOperation === 'CREDIT' ? '#4CAF50' : '#F44336'};">
      ${item.typeOperation === 'DEBIT' ? '-' : '+'}${item.amount} FCFA
    </span><br><br>

    <strong style="color: #4CAF50;">📅 Date et Heure</strong><br>
    ${this.formatDate(item.dateTransaction)}<br><br>

    <strong style="color: #4CAF50;">🔄 Type d'Opération</strong><br>
    ${item.typeOperation}<br><br>

    <strong style="color: #4CAF50;">💳 Méthode de Paiement</strong><br>
    ${item.paymentMethod || 'N/A'}<br><br>

    <strong style="color: #4CAF50;">🔐 Authentification</strong><br>
    ${item.typeAuth}<br><br>

    <strong style="color: #4CAF50;">📊 Niveau</strong><br>
    ${this.formatNiveau(item.level)}<br><br>

    <strong style="color: #4CAF50;">✅ Statut</strong><br>
    ${item.status}<br><br>

    <strong style="color: #4CAF50;">📝 Raison</strong><br>
    ${item.reason}<br><br>

    <strong style="color: #4CAF50;">💳 Soldes</strong><br>
    Avant: ${item.balanceBefore} FCFA<br>
    Après: ${item.balanceAfter} FCFA<br><br>

    <hr style="margin: 15px 0;">
    <small style="color: #757575;">
      Transaction ID: ${item.transactionUid}<br>
      Référence: #${item.id}
    </small>
  `;

      this.detailsRechargeDialog = true;
      this.detailsRechargeContent = details;
    },

        getPaymentMethodRechargeColor(method) {
      if (!method || method === 'N/A') return 'grey';

      const colors = {
        "CASH": "green",
        "BANK_TRANSFER": "blue",
        "CHECK": "orange",
        "MOBILE_MONEY": "purple",
        "CARD": "indigo",
        "CREDIT_CARD": "indigo",
        "DEBIT_CARD": "teal",
        "ELECTRONIC": "cyan",
        "WAVE": "blue",
        "ORANGE_MONEY": "orange",
        "FREE_MONEY": "red",
        "ADMIN_CREDIT": "primary",
        "SYSTEM": "grey"
      };

      return colors[method.toUpperCase()] || "grey";
    },

    getPaymentMethodRechargeIcon(method) {
      if (!method || method === 'N/A') return 'mdi-help-circle';

      const icons = {
        "CASH": "mdi-cash",
        "BANK_TRANSFER": "mdi-bank-transfer",
        "CHECK": "mdi-checkbook",
        "MOBILE_MONEY": "mdi-cellphone",
        "CARD": "mdi-credit-card",
        "CREDIT_CARD": "mdi-credit-card",
        "DEBIT_CARD": "mdi-credit-card-outline",
        "ELECTRONIC": "mdi-web",
        "WAVE": "mdi-water",
        "ORANGE_MONEY": "mdi-phone",
        "FREE_MONEY": "mdi-gift",
        "ADMIN_CREDIT": "mdi-account-supervisor",
        "SYSTEM": "mdi-cog"
      };

      return icons[method.toUpperCase()] || "mdi-wallet";
    },

    clearSearchRecharges() {
      this.searchQueryRecharges = "";
    },

    // ===== MÉTHODES GÉNÉRALES =====

    updateDateRangeRepas(period) {
      switch (period) {
        case 'today':
          this.dateDebutRepas = moment().format('YYYY-MM-DD');
          this.dateFinRepas = moment().format('YYYY-MM-DD');
          break;
        case 'week':
          this.dateDebutRepas = moment().startOf('week').format('YYYY-MM-DD');
          this.dateFinRepas = moment().endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          this.dateDebutRepas = moment().startOf('month').format('YYYY-MM-DD');
          this.dateFinRepas = moment().endOf('month').format('YYYY-MM-DD');
          break;
        case 'last_month':
          this.dateDebutRepas = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.dateFinRepas = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
          break;
        case 'custom':
          break;
      }
    },

    // CORRECTION : refreshData améliorée
    async refreshData() {
      try {
        this.loading = true;

        // Reset filters
        this.selectedPeriodRepas = "month";
        this.selectedPeriodRecharges = "month";
        this.selectedPeriodExternal = "month";
        this.selectedRestaurant = "Tous les restaurants";
        this.selectedTypeRecharge = "Tous";
        this.selectedStatusRecharge = "Tous";
        this.selectedPaymentMethodRecharge = "Tous";
        this.selectedPaymentMethod = "Tous";
        this.selectedStatusExternal = "Tous";
        this.searchQueryRepas = "";
        this.searchQueryRecharges = "";
        this.searchQueryExternal = "";
        this.updateDateRangeRepas("month");
        this.updateDateRangeRecharges("month");
        this.updateDateRangeExternal("month");

        // Reload all data
        await this.loadData();

        // Dans la méthode refreshData(), modifier la section recharges :
        if (this.activeTab === 'tab-recharges') {
          await this.loadRecharges();
          await this.getRechargeStatistics();
          this.$nextTick(() => {
            this.calculateRechargeStatsFromTransactions();
          });
        } else if (this.activeTab === 'tab-paiements-externes') {
          await this.loadExternalPayments();
          // Recalculer les stats après le chargement
          this.$nextTick(() => {
            this.calculateExternalStatsFromTransactions();
          });
        }

        let message = "Toutes les données ont été mises à jour";
        if (this.activeTab === 'tab-recharges' && this.recharges.length === 0) {
          message = "Données actualisées. Aucun historique de recharge disponible.";
        } else if (this.activeTab === 'tab-paiements-externes' && this.externalPayments.length === 0) {
          message = "Données actualisées. Aucun historique de paiement externe disponible.";
        }

        this.showAlert("success", "Actualisation réussie", message);
        this.$vuetify.goTo(0);

      } catch (error) {
        console.error("Error during refresh:", error);
        this.showAlert("error", "Erreur", "Erreur lors de l'actualisation des données");
      } finally {
        this.loading = false;
      }
    },

    initialize() {
      this.balanceInfos.matricule = sessionStorage.getItem("userId");
      this.balanceInfos.companyName = sessionStorage.getItem("companyName");
      this.loadData();
    },

    async loadData() {
      this.loading = true;
      const errors = [];

      try {
        await Promise.allSettled([
          this.getTransactions().catch(e => errors.push("transactions")),
          this.getBalanceInfos().catch(e => errors.push("balance")),
          this.getNumberMealsEmployee().catch(e => errors.push("financial"))
        ]);

        if (errors.length > 0) {
          console.warn("Some data failed to load:", errors);
        }
      } finally {
        this.loading = false;
      }
    },

    async getTransactions() {
      // Always load 6 months of data
      const startDate = moment().subtract(6, "months").format("YYYY-MM-DD");
      const endDate = moment().add(1, "day").format("YYYY-MM-DD");

      const url = `${this.$store.getters.user.baseUrl}/wallet/get_wallet_transactions_for_one_employee/${startDate}/${endDate}/${sessionStorage.getItem("userId")}/${sessionStorage.getItem("companyId")}/${sessionStorage.getItem("accountId")}`;

      try {
        const response = await apiClient.get(url);
        if (response.data.status === 200 && response.data.datas) {
          // Map all transactions
          const allTransactions = response.data.datas.map(item => ({
            id: item.id,
            date: item.dateTransaction,
            dateCommande: item.dateCommand,
            restaurant: item.restaurantName,
            typeRepas: this.getTypeRepas(item.dateCommand),
            montant: item.price,
            paiement: item.typeAuth,
            niveau: item.level,
            statut: item.status,
            infos: item.infos,
            origine: item.orderOrigin,
            transactionUid: item.transaction_uid
          }));

          // Group by transactionUid
          const grouped = {};
          allTransactions.forEach(transaction => {
            if (!grouped[transaction.transactionUid]) {
              grouped[transaction.transactionUid] = {
                principal: null,
                details: []
              };
            }

            if (transaction.niveau === 'PRINCIPAL') {
              grouped[transaction.transactionUid].principal = transaction;
            } else {
              grouped[transaction.transactionUid].details.push(transaction);
            }
          });

          // Convert to array with expandable structure
          this.transactions = Object.keys(grouped).map(uid => {
            const group = grouped[uid];
            return {
              ...group.principal,
              _expanded: false,
              _children: group.details
            };
          });

          // Extract unique restaurants
          const restaurants = [...new Set(allTransactions.map(t => t.restaurant))];
          this.restaurantOptions = ["Tous les restaurants", ...restaurants];
        }
      } catch (error) {
        console.error("Error loading transactions:", error);
      }
    },

    async getBalanceInfos() {
      const url = `${this.$store.getters.user.baseUrl}/wallet/get_infos_employee_by_matricule/${sessionStorage.getItem("userId")}/null/${sessionStorage.getItem("companyId")}/MANUEL/${sessionStorage.getItem("accountId")}`;

      try {
        const response = await apiClient.get(url);
        if (response.data.status === 200) {
          Object.assign(this.balanceInfos, response.data.datas);
        }
      } catch (error) {
        console.error("Error loading balance info:", error);
      }
    },

    async getNumberMealsEmployee() {
      const url = `${this.$store.getters.user.baseUrl}/wallet/get_financial_details_for_one_employee/${sessionStorage.getItem("userId")}/${sessionStorage.getItem("companyId")}/${sessionStorage.getItem("accountId")}`;

      try {
        const response = await apiClient.get(url);
        if (response.data.status === 200) {
          Object.assign(this.financialDetails, response.data.datas);
        }
      } catch (error) {
        console.error("Error loading financial details:", error);

        if (error.response && error.response.status === 500) {
          this.showAlert("warning", "Données partiellement chargées",
              "Certaines informations financières ne sont pas disponibles pour le moment.");

          this.financialDetails = {
            ...this.financialDetails,
            budgetAllouer: "N/A",
            montantConsommerMoisEnCours: "0",
            budgetRestant: "N/A",
            seraDeduit: "0"
          };
        }
      }
    },

    clearSearchRepas() {
      this.searchQueryRepas = "";
    },

    formatDate(date) {
      if (!date || date === "0") return "N/A";
      return moment(date).format("DD-MM-YYYY");
    },

    getTypeRepas(date) {
      const hour = moment(date).hour();
      return hour < 15 ? "Déjeuner" : "Dîner";
    },

    getPaymentColor(payment) {
      switch (payment?.toLowerCase()) {
        case "carte":
          return "blue";
        case "espèces":
          return "green";
        case "ticket":
          return "orange";
        default:
          return "grey";
      }
    },

    getStatusColor(status) {
      switch (status?.toLowerCase()) {
        case "success":
          return "green";
        case "failed":
          return "red";
        case "cancelled":
          return "orange";
        default:
          return "grey";
      }
    },

    getStatusIcon(status) {
      switch (status?.toLowerCase()) {
        case "success":
          return "mdi-check-circle";
        case "failed":
          return "mdi-close-circle";
        case "cancelled":
          return "mdi-cancel";
        default:
          return "mdi-help-circle";
      }
    },

    canDelete(item) {
      return sessionStorage.getItem("userId")?.toLowerCase() === "admin" &&
          item.statut?.toLowerCase() === "success" &&
          item.origine?.toLowerCase() !== "internet";
    },

    viewDetailsRepas(item) {
      const details = `
    <strong style="color: #1976D2;">🍽️ Restaurant</strong><br>
    ${item.restaurant}<br><br>

   <strong style="color: #1976D2;">📅 Date Commande</strong><br>
    ${this.formatDate(item.dateCommande)}<br><br>

    <strong style="color: #1976D2;">🕒 Date Transaction</strong><br>
    ${this.formatDateWithTime(item.date)}<br><br>

    <strong style="color: #1976D2;">🍴 Type de Repas</strong><br>
    ${item.typeRepas}<br><br>

    <strong style="color: #1976D2;">💰 Montant</strong><br>
    <span style="font-size: 16px; font-weight: bold; color: #E65100;">${item.montant} FCFA</span><br><br>

    <strong style="color: #1976D2;">💳 Mode de Paiement</strong><br>
    ${item.paiement}<br><br>

    <strong style="color: #1976D2;">📊 Niveau</strong><br>
    ${item.niveau || 'N/A'}<br><br>

    <strong style="color: #1976D2;">✅ Statut</strong><br>
    <span style="color: ${this.getStatusColor(item.statut)}; font-weight: bold;">${this.getStatusText(item.statut)}</span><br><br>

    <strong style="color: #1976D2;">🌐 Origine</strong><br>
    ${item.origine || 'N/A'}<br><br>

    ${item.infos && item.infos !== 'null' ? `<strong style="color: #1976D2;">ℹ️ Informations supplémentaires</strong><br>${item.infos}<br><br>` : '<strong style="color: #1976D2;">ℹ️ Informations supplémentaires</strong><br><span style="color: #9E9E9E; font-style: italic;">Aucune information supplémentaire</span><br><br>'}

    <hr style="margin: 15px 0;">
    <small style="color: #757575;">
      Transaction ID: ${item.transactionUid}<br>
      Référence: #${item.id}
    </small>
  `;

      this.detailsDialog = true;
      this.detailsContent = details;
    },

    getStatusText(status) {
      switch (status?.toLowerCase()) {
        case "success":
          return "Transaction réussie";
        case "failed":
          return "Transaction échouée";
        case "cancelled":
          return "Transaction annulée";
        default:
          return "Statut inconnu";
      }
    },

    async deleteTransaction(item) {
      if (!this.canDelete(item)) {
        this.showAlert("error", "Action non autorisée",
            "Vous n'avez pas les droits pour annuler cette transaction.");
        return;
      }

      if (confirm("Êtes-vous sûr de vouloir annuler cette transaction ?")) {
        this.loading = true;
        try {
          const url = `${this.$store.getters.user.baseUrl}/wallet/delete_wallet_transaction_by_uuid/${item.transactionUid}/${sessionStorage.getItem("accountId")}`;
          const response = await apiClient.delete(url);

          if (response.data.status === 200) {
            this.showAlert("success", "Succès", response.data.message);
            await this.loadData();
          } else {
            this.showAlert("error", "Erreur", response.data.message);
          }
        } catch (error) {
          this.showAlert("error", "Erreur", "Impossible d'annuler la transaction");
        } finally {
          this.loading = false;
        }
      }
    },

    showAlert(color, title, message) {
      this.alertColor = color;
      this.alertTitle = title;
      this.alertMessage = message;
      this.alertDialog = true;
    },

    formatNiveau(niveau) {
      switch (niveau) {
        case 'PRINCIPAL':
          return 'TOTAL';
        case 'SECONDAIRE_COMPANY':
          return 'ENTREPRISE';
        case 'SECONDAIRE_PERSONNEL':
          return 'PERSONNEL';
        default:
          return niveau || 'N/A';
      }
    },

    getNiveauColor(niveau) {
      switch (niveau) {
        case 'PRINCIPAL':
          return 'primary';
        case 'SECONDAIRE_COMPANY':
          return 'orange';
        case 'SECONDAIRE_PERSONNEL':
          return 'purple';
        default:
          return 'grey';
      }
    },
  }
};
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
  font-size: 1.1rem;
}

.v-data-table {
  font-size: 0.9rem;
}

/* Style pour les en-têtes de colonnes */
.v-data-table >>> thead tr th {
  font-size: 0.95rem !important;
  font-weight: 600 !important;
  color: #1976D2 !important;
  background-color: #F5F5F5 !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 16px !important;
}

/* Ajouter une bordure sous les en-têtes */
.v-data-table >>> thead tr {
  border-bottom: 2px solid #E0E0E0;
}

/* Style au survol des en-têtes */
.v-data-table >>> thead tr th:hover {
  background-color: #EEEEEE !important;
  cursor: pointer;
}

/* Icônes de tri plus visibles */
.v-data-table >>> thead tr th .v-icon {
  color: #1976D2 !important;
  font-size: 20px !important;
}

/* Amélioration de l'apparence des cartes */
.v-card {
  transition: all 0.3s ease;
}

.v-card:hover {
  transform: translateY(-2px);
}

/* Style pour les statistiques */
.text-caption {
  font-size: 0.75rem !important;
  color: #666;
}

/* Amélioration du tableau */
.v-data-table >>> .v-data-table__wrapper {
  border-radius: 4px;
}

/* Style pour les boutons de sélection de période */
.v-btn-toggle {
  flex-wrap: wrap;
  display: inline-flex !important;
}

.v-btn-toggle .v-btn {
  min-width: 120px;
  margin: 2px;
}

/* Centrer le contenu de la colonne */
.text-center {
  text-align: center;
}

.justify-center {
  justify-content: center;
}

/* Amélioration de la transition */
.v-expand-transition {
  transition: all 0.3s ease-in-out;
}

/* Responsive */
@media (max-width: 600px) {
  .v-card-title {
    font-size: 1rem;
  }

  h2 {
    font-size: 1.5rem !important;
  }

  /* Masquer certaines colonnes sur mobile */
  .v-data-table >>> th:nth-child(6),
  .v-data-table >>> td:nth-child(6) {
    display: none;
  }
}

/* Styles pour les onglets - version simplifiée */
@media (max-width: 960px) {
  .v-tabs >>> .v-tab {
    flex-direction: row !important;
    min-width: auto !important;
    padding: 0 12px !important;
  }

  .v-tabs >>> .v-tab .v-icon {
    margin-bottom: 0 !important;
    margin-right: 8px !important;
  }

  .v-tabs >>> .v-tabs-bar {
    justify-content: center !important;
  }
}

@media (max-width: 600px) {
  .v-tabs >>> .v-tab {
    font-size: 0.75rem !important;
    padding: 0 8px !important;
  }

  .v-tabs >>> .v-tab .v-icon {
    font-size: 18px !important;
    margin-right: 4px !important;
  }

  /* Adapter la taille des avatars sur mobile */
  .v-avatar {
    width: 24px !important;
    height: 24px !important;
  }

  /* Réduire la taille des chips sur mobile */
  .v-chip--small {
    font-size: 0.6rem !important;
    height: 20px !important;
  }
}

/* Animation pour les chips */
.v-chip {
  transition: all 0.3s ease;
}

.v-chip:hover {
  transform: scale(1.05);
}

/* Styles pour les onglets - version simplifiée */
@media (max-width: 960px) {
  .v-tabs >>> .v-tab {
    flex-direction: row !important;
    min-width: auto !important;
    padding: 0 12px !important;
  }

  .v-tabs >>> .v-tab .v-icon {
    margin-bottom: 0 !important;
    margin-right: 8px !important;
  }

  .v-tabs >>> .v-tabs-bar {
    justify-content: center !important;
  }
}

@media (max-width: 600px) {
  .v-tabs >>> .v-tab {
    font-size: 0.75rem !important;
    padding: 0 8px !important;
  }

  .v-tabs >>> .v-tab .v-icon {
    font-size: 18px !important;
    margin-right: 4px !important;
  }
}
</style>